import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import DashboardList from "../../Components/Layouts/DashboardList";
import { getList, deleteEntityById, sortEntityById } from "../../Redux/Package/actions";
import { getList as getCategoryList } from "../../Redux/Category/actions";

function List({
  useAuth,
  getList,
  list,
  loginData,
  onDelete,
  onSort,
  getCategoryList,
  categoryList,
}) {
  let tokenData = loginData.data;
  const [filter_options, setFilterOptions] = useState();

  useEffect(() => {
    if (!list.data) {
      getList(tokenData);
    }
    if (!categoryList.data) {
      getCategoryList(tokenData);
    }
    if (categoryList.data) {
      setFilterOptions(
        categoryList?.data?.data
          .filter((e) => e.type?.category_key === "destination")
          .map((itm) => {
            const { id, title, children } = itm;
            return {
              value: id,
              text: title,
              ...(children && {
                children: children?.map((child) => {
                  const { id, title, children } = child;
                  return {
                    value: id,
                    text: title,
                    ...(children && {
                      children: children?.map((gChild) => {
                        const { id, title } = gChild;
                        return {
                          value: id,
                          text: title,
                        };
                      }),
                    }),
                  };
                }),
              }),
            };
          })
      );
    }
  }, [list.data, categoryList.data]);

  console.log(onSort);

  const tableConfig = {
    title: "Packages",
    filterOptionTitle: "Category",
    filterOptions: filter_options,
    applyFilter: true,
    tableColumns: [
      { name: "Status", selector: "status", width: "3%" },
      { name: "Title", selector: "package_title", width: "70%" },
      { name: "Order", selector: "order", width: "3%" },
      { name: "Modified Date", selector: "updated_at", width: "17%" },
      { name: "ID", selector: "id", width: "5%" },
    ],
    filterByColumn: "package_cats",
    searchByColumn: "package_title",
    updatePath: "/package/update",
    addPath: "/package/add",
    noDataMessage: "No Package exists",
    updateLinkColumn: "package_title",
    deleteBtnText: "Delete",
    deleteItemsByIdList: (idList) => {
      onDelete(idList);
    }, 
    sortItemsByIdList: (idList) => {
      onSort(idList);
    } 
  };

  return (
    <DashboardList
      useAuth={useAuth}
      getList={getList}
      dataToList={list}
      tableConfig={tableConfig}
    />
  );
}

const mapStateToProps = (state) => {
  return {
    list: state.packages,
    categoryList: state.category,
    loginData: state.loginData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getList: (tokenData) => dispatch(getList(tokenData)),
    getCategoryList: (tokenData) => dispatch(getCategoryList(tokenData)),
    onDelete: (idList) => dispatch(deleteEntityById(idList)),
    onSort: (idList) => dispatch(sortEntityById(idList)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(List);
